// extracted by mini-css-extract-plugin
export default {"ContactList":"Contacts_ContactList__3-CQt","ContactItem":"Contacts_ContactItem__A3D-G","ContactLink":"Contacts_ContactLink__7Iw0z"};